import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { GetIdeaBoardOutput } from "types/web-app";

export const getIdeaBoard = async (accessToken: string) => {
  try {
    const response = await fetchWithAuth("/ideas/board", accessToken);
    const data = (await response.json()) as ServiceResponse<GetIdeaBoardOutput>;
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
